import { Link } from "react-router-dom";
import { Badges, H5, LI, SVG, UL } from "../../../../AbstractElements";
import { Href, Messages } from "../../../../utils/Constant";
import UseOutsideDropdown from "../../../../utils/UseOutsideDropdown";
import MessagesBox from "./MessagesBox";

const MessagesHeader = () => {
  const { ref, isComponentVisible, setIsComponentVisible } = UseOutsideDropdown(false);

  return (
    <LI className="custom-dropdown">
      <Link to={Href} ref={ref} onClick={() => setIsComponentVisible(!isComponentVisible)}>
        <SVG className="svg-color" iconId="Message" />
      </Link>
      <Badges pill color="tertiary">
        3
      </Badges>
      <div className={`custom-menu message-dropdown py-0 overflow-hidden ${isComponentVisible ? "show" : ""}`}>
        <H5 className="title bg-primary-light">{Messages}</H5>
        <UL>
          <MessagesBox />
        </UL>
      </div>
    </LI>
  );
};

export default MessagesHeader;
